// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6944) return "static/chunks/6944-d6d84e3d4b254d26.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"899":"a588f219798d35bf","3450":"ff529064c82d2076","4740":"9855352c48424082","5019":"23a80bf967361a5c","6821":"a79494bdd29d28e0","7974":"a0b00663586e1621"}[chunkId] + ".js";
};